// extracted by mini-css-extract-plugin
export var parcelRow = "_w3-0";